import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import type { ClientRow } from '../../api';
import { useData } from '../../useData';
import { ErrorMsg } from '../../components/Modal';
import { expiryStatus, fmtDate } from '../../lib/clients';
import { formatPhone } from '../../lib/dialCodes';

/** Lista clienților unei aplicații „Clienți”. */
export function ClientsPage() {
  const appId = Number(useParams().appId);
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [query, setQuery] = useState('');
  useEffect(() => {
    const t = setTimeout(() => setQuery(q.trim()), 300);
    return () => clearTimeout(t);
  }, [q]);
  const { data, error, loading } = useData<{ clients: ClientRow[]; canCreate: boolean }>(
    `/apps/${appId}/clients${query ? `?q=${encodeURIComponent(query)}` : ''}`);

  return (
    <>
      <div className="page-head">
        <h1>Clienți</h1>
        {data?.canCreate && <button className="primary" onClick={() => navigate(`/a/${appId}/nou`)}>+ Client nou</button>}
      </div>
      <ErrorMsg error={error} />
      <input className="search" placeholder="Caută după nume, ID, telefon, e-mail sau CNP…" value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
      {loading && !data && <p className="muted">Se încarcă…</p>}
      {data && data.clients.length === 0 && (
        <p className="muted">{query ? 'Niciun client găsit.' : 'Niciun client încă. Adăugați primul client — puteți porni de la actul de identitate.'}</p>
      )}
      {data && data.clients.length > 0 && (
        <table>
          <thead>
            <tr><th>ID</th><th>Nume</th><th>Telefon</th><th>E-mail</th><th>Localitate</th><th>Documente</th><th>Prima expirare</th></tr>
          </thead>
          <tbody>
            {data.clients.map((c) => {
              const st = expiryStatus(c.primaExpirare);
              return (
                <tr key={c.id} className="clickable" onClick={() => navigate(`/clienti/${c.id}`)}>
                  <td className="id-cell">{String(c.id).padStart(6, '0')}</td>
                  <td><Link to={`/clienti/${c.id}`} onClick={(e) => e.stopPropagation()}><strong>{c.nume}</strong> {c.prenume}</Link></td>
                  <td className="nowrap">{c.telefon ? formatPhone(c.telefon) : '—'}</td>
                  <td className="muted">{c.email ?? '—'}</td>
                  <td>{[c.localitate, c.judet].filter(Boolean).join(', ') || '—'}</td>
                  <td>{c.documente || '—'}</td>
                  <td>{c.primaExpirare ? <>{fmtDate(c.primaExpirare)} {st && st.cls !== 'tag ok' && <span className={st.cls}>{st.label}</span>}</> : '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
